module.exports = __webpack_public_path__ + "static/media/product3.17ef68af.png";